import { TagRequest } from '~src/httpClient/TAG/TagRequest';

import { IGetItemsResult } from '../../../../../httpClient/serverApi/types/IGetItemsResult';
import { IAnalyticsExtConnectionSettings } from '../../../../types/ISiteSettingsForSiteAdmin';

export interface IGetAnalyticsExtConnectionSettingsResult extends IGetItemsResult {
  connectionList: IAnalyticsExtConnectionSettings[];
}

export class GetAnalyticsExtConnectionSettingsRequest extends TagRequest<{}, IGetAnalyticsExtConnectionSettingsResult> {
  constructor() {
    super('analyticsextensions', 'getAnalyticsExtensionsConnections', {});
  }
}
